import { EventEmitter } from "events";

const ee = new EventEmitter();

export default ee;
